import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import { Store } from 'redux';
import { createReceiveMessageAction } from 'streamsState/store/streamedData/actions.ts';
import { Logger } from '@instinet-analytics/core-lib';
import { VolumeCurveElement } from 'widgets/volumeCurve/api/VolumeCurveElement.ts';

export function getVolumeCurveMessageHandler(
    store: Store,
    logger: Logger
): StreamDataHandlers<VolumeCurveElement> {
    return {
        onMessage: (streamKey: string, message: VolumeCurveElement) => {
            store.dispatch(
                createReceiveMessageAction(
                    'startVolumeCurveStream',
                    streamKey,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    message as any
                )
            );
        },
        onError: (streamKey: string, error: StreamError) => {
            logger.critical('Error in startVolumeCurveStream stream', {
                streamKey,
                error,
            });
        },
    };
}
